module.exports = __webpack_public_path__ + "static/media/figureman-2.84793b10.png";